<template>
  <div class="login-page">
    <!-- banner -->
    <div class="banner">
      <img src="../assets/images/login-banner.png" alt="" />
    </div>
    <!-- 登录 -->
    <div class="login">
      <div class="login-title">陪护服务员&管理员登录</div>
      <div class="login-input flex-colc">
        <input
          type="number"
          placeholder="请输入手机号码"
          v-model.number="params.loginname"
          @keyup.enter="handleLogin"
        />
        <input
          placeholder="请输入密码"
          v-model.trim="params.loginpwd"
          @keyup.enter="handleLogin"
          @input="handleInput"
        />
      </div>
      <div
        class="login-button"
        :class="{ disabled: isSubmitting }"
        @click="handleLogin"
      >
        {{ isSubmitting ? "登录中..." : "登录" }}
      </div>
      <div class="login-footer">
        <div class="login-footer-top">忘记密码?</div>
        <div class="login-footer-btm" @click="handleRegister">
          注册新用户 | 陪护服务员认证→
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
import { login } from "../api/public";
export default {
  name: "login",
  data() {
    return {
      params: {
        usertype: 1, // 1 个人用户 2 企业用户
        loginname: "",
        loginpwd: "",
      },
      // 新增是否提交中的状态
      isSubmitting: false,
    };
  },
  methods: {
    async handleLogin() {
      // 如果正在提交，直接返回
      if (this.isSubmitting) return; // 防止重复提交

      try {
        let { loginname, loginpwd } = this.params;
        // 验证手机号是否为空
        if (!loginname) {
          this.$toast("请输入手机号");
          return;
        }
        // 验证手机号格式是否正确
        if (!/^1[3456789]\d{9}$/.test(loginname)) {
          this.$toast("请输入正确的手机号");
          return;
        }
        // 验证密码是否为空
        if (!loginpwd) {
          this.$toast("请输入密码");
          return;
        }
        // 设置为提交中
        this.isSubmitting = true;
        this.$toast.loading({
          message: "登录中...",
          forbidClick: true,
          duration: 0, // 持续时间为 0，防止自动关闭
        });

        // 设置假数据
        // const res = {
        //   result: true,
        //   message: "登录成功",
        //   code: "o4j7y63er8Vf1u4Sjycg3m8kalak",
        // }

        const res = await login(this.params);
        // 等待1秒
        await new Promise((resolve) => setTimeout(resolve, 500));
        if (res.result) {
          //   this.$toast.success(res.message);
          // 更新 openid
          this.$store.commit("updateOpenid", res.code);
          // 等待用户信息加载完成
          await this.$store.dispatch("fetchUserInfo", res.code);

          // 根据用户信息是否获取成功进行跳转
          if (this.$store.state.USERINFO && this.$store.state.USERINFO.id) {
            // 关闭加载提示
            this.$toast.clear();
            this.$router.push("/home/personal");
          } else {
            // 用户信息获取失败，提示并跳转回登录页
            this.$toast.fail("用户信息获取失败，请重新登录");
            this.$store.commit("updateOpenid", "");
            this.$store.commit("updateUserInfo", "");
            // 无论成功或失败，都将提交状态设置为 false
            this.isSubmitting = false;
          }
        } else {
          // 无论成功或失败，都将提交状态设置为 false
          this.isSubmitting = false;
          // 关闭加载提示
          //   this.$toast.clear();
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      } catch (e) {
        // 无论成功或失败，都将提交状态设置为 false
        this.isSubmitting = false;
        // 关闭加载提示
        // this.$toast.clear();
        console.error("登录请求出错:", e);
        this.$toast.fail("登录请求出错，请稍后重试");
      }
    },
    handleInput() {
      // 只能输入英文、数字，不能输入空格
      this.params.loginpwd = this.params.loginpwd.replace(/[^a-zA-Z0-9]/g, "");
    },
    handleRegister() {
      this.$router.push("/register");
    },
    handleGo(url) {
      this.$router.push(url);
    },
  },
};
</script>
  <style lang="less">
.login-page {
  min-height: 100vh;
  padding-bottom: 100px;
  box-sizing: border-box;
  background: #fff;
  .login {
    .login-title {
      font-size: 36px;
      color: #0031c9;
      text-align: center;
      font-weight: bold;
      margin: 73px auto 58px;
    }
    .login-input {
      input {
        width: 600px;
        height: 90px;
        border: 1px solid #adadad;
        border-radius: 45px;
        font-size: 24px;
        text-align: center;
        margin-bottom: 40px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .login-button {
      margin: 87px auto 70px;
      width: 300px;
      height: 90px;
      text-align: center;
      line-height: 90px;
      background: #0031c9;
      border-radius: 45px;
      font-size: 30px;
      color: #fff;
      cursor: pointer;
      &.disabled {
        background: #ccc;
        cursor: not-allowed;
      }
    }
    .login-footer {
      font-size: 24px;
      color: #464646;
      text-align: center;
      .login-footer-top {
        margin-bottom: 59px;
      }
    }
  }
}
</style>